export const path = '/merge-players';
